import { Navigate } from "react-router-dom";
import ZoneMaster from "../components/pages/ZoneMaster";
import AreaMaster from "../components/pages/AreaMaster";
import DashboardHome from "../components/pages/DashboardHome";
import Dispatch from "../components/pages/Dispatch";
import AllVins from "../components/AllVins";
import DispatchedHistory from "../components/DispatchedHistory";
import VinDetails from "../components/VinDetails";
import MapCompnent from "../components/MapComponent";
import AddNewZone from "../components/AddNewZone";
import ZoneDetails from "../components/ZoneDetails";
import AddNewArea from "../components/AddNewArea";
import AreaDetails from "../components/AreaDetails";
import Table from "../components/Table";
import LandingPage from "../components/pages/LandingPage";
import TestTabel from "../components/TestTabel";
import ErrorPage from "../components/pages/ErrorPage";
import UsageAnalytics from '../components/pages/UsageAnalytics'
import AddNewDriver from "../components/AddNewDriver/AddNewDriver";
import DriverMaster from "../components/pages/DriverMaster";
import DashboardAnalytics from "../components/pages/DashboardAnalytics/DashboardAnalytics";
import DeviceMaster from "../components/pages/DeviceMaster";
import AddNewDevice from "../components/AddNewDevice/AddNewDevice";
import DeviceAssignment from "../components/pages/DeviceAssignment";
import PlantMaster from '../components/pages/PlantMaster';
import EditPlantMaster from '../components/EditPlantMaster';
import PlantDetails from '../components/PlantDetails';

// all routes(add here if new routes needed)
export const routes_all = [
    { path: "/*", name: "Dashboard", Component: <Navigate replace={true} to="/" />, },
    { path: "/", name: "Landing Page", Component: <LandingPage /> },
    // Pages
    { path: "/dashboard", name: "Dashboard", Component: <DashboardHome /> },
    { path: "/dispatched", name: "Dispatched", Component: <DispatchedHistory /> },
    { path: "/zone-master", name: "Zone Master", Component: <ZoneMaster /> },
    { path: "/area-master", name: "Area Master", Component: <AreaMaster /> },
    { path: "/dashboard-analytics", name: "Dashboard Analytics", Component: <DashboardAnalytics /> },
    { path: "/dashboard/all-VINs", name: "Vins", Component: <AllVins /> },
    { path: "/dispatched/dispatched-history", name: "Dispatched History", Component: <DispatchedHistory />, },
    // VIN Details
    { path: "/dashboard/all-VINs/vin-details", name: "VIN Details", Component: <VinDetails />, },
    { path: "/dashboard/vin-details", name: "VIN Details", Component: <VinDetails />, },
    { path: "/dispatched/vin-details", name: "VIN Details", Component: <VinDetails />, },
    // Zone
    { path: "/zone-master/map-view", name: "Zone Map Detail", Component: <MapCompnent />, },
    { path: "/zone-master/add-new-zone", name: "Add New Zone", Component: <AddNewZone />, },
    { path: "/zone-master/zone-details", name: "Zone Detail", Component: <ZoneDetails />, },
    { path: "/zone-master/edit-zone", name: "Edit Zone", Component: <AddNewZone />, },
    // Area
    { path: "/area-master/add-new-area", name: "Add New Area", Component: <AddNewArea />, },
    { path: "/area-master/area-details", name: "Area Detail", Component: <AreaDetails />, },
    { path: "/area-master/edit-area", name: "Edit Area", Component: <AddNewArea />, },
    // Usage Analytics
    { path: "/usage-analytics", name: "Usage Analytics", Component: <UsageAnalytics />, protected: true },
    // Driver
    { path: "/driver-master", name: "Driver Master", Component: <DriverMaster />, protected: true },
    { path: "/driver-master/add-new-driver", name: "Add New Driver", Component: <AddNewDriver />, protected: true },
    { path: "/driver-master/edit-driver", name: "Edit Driver", Component: <AddNewDriver />, protected: true },
    // Device
    { path: "/device-master", name: "Driver Master", Component: <DeviceMaster />, protected: true },
    { path: "/device-master/add-new-device", name: "Add New Driver", Component: <AddNewDevice />, protected: true },
    { path: "/device-master/edit-device", name: "Edit Driver", Component: <AddNewDevice />, protected: true },
    // Device Assignment
    { path: "/device-assignment", name: "Driver Assignment", Component: <DeviceAssignment />, protected: true },
    // dev
    { path: "/Tabel", name: "Test", Component: <TestTabel /> },
    { path: "/error", name: "Test", Component: <ErrorPage /> },
    // Plant Master
    { path: "/plant-master", name: "Plant Master", Component: <PlantMaster />, },
    { path: "/plant-master/edit-plant", name: "Edit Plant", Component: <EditPlantMaster />, },
    { path: "/plant-master/plant-details", name: "Plant Details", Component: <PlantDetails />, },
];
// provide user to access routes based on their role(should be added if new routes is added)
export const ROUTE_PRIVILEGE = {
    viewer: ["/",
        "/dashboard",
        "/dispatched",
        "/zone-master",
        "/area-master",
        "/dashboard/all-VINs",
        "/dispatched/dispatched-history",
        "/dashboard/all-VINs/vin-details",
        "/dashboard/vin-details",
        "/dispatched/vin-details",
        "/zone-master/map-view",
        "/zone-master/zone-details",
        "/area-master/area-details",
        "/Tabel",
        "/error"],

    dispatch: ["/",
        "/dashboard",
        "/dispatched",
        "/zone-master",
        "/area-master",
        "/dashboard/all-VINs",
        "/dispatched/dispatched-history",
        "/dashboard/all-VINs/vin-details",
        "/dashboard/vin-details",
        "/dispatched/vin-details",
        "/zone-master/map-view",
        "/zone-master/zone-details",
        "/area-master/area-details",
        "/Tabel",
        "/error"],
    manufacturing: ["/", "/dashboard", "/dispatched", "/zone-master", "/area-master", "/dashboard/all-VINs", "/dispatched/dispatched-history", "/plant-master", "/plant-master/edit-plant", "/plant-master/plant-details", "/dashboard/all-VINs/vin-details", "/dashboard/vin-details", "/dispatched/vin-details", "/zone-master/map-view", "/zone-master/add-new-zone", "/zone-master/zone-details", "/zone-master/edit-zone", "/area-master/add-new-area", "/area-master/area-details", "/area-master/edit-area", "/usage-analytics", "/driver-master", "/driver-master/add-new-driver", "/driver-master/edit-driver", "/device-master", "/device-master/add-new-device", "/device-master/edit-device", "/device-assignment", "/Tabel", "/error"],
    admin: ["/", "/dashboard", "/dashboard-analytics", "/dispatched", "/zone-master", "/area-master", "/dashboard/all-VINs", "/dispatched/dispatched-history", "/dashboard/all-VINs/vin-details", "/dashboard/vin-details", "/dispatched/vin-details", "/zone-master/map-view", "/zone-master/add-new-zone", "/zone-master/zone-details", "/zone-master/edit-zone", "/area-master/add-new-area", "/area-master/area-details", "/area-master/edit-area", "/usage-analytics", "/driver-master", "/driver-master/add-new-driver", "/driver-master/edit-driver", "/device-master", "/device-master/add-new-device", "/device-master/edit-device", "/device-assignment", "/Tabel", "/error"],
};
// keys for the module on landing page
export const LANDING_PAGE_MODULE_CODE = {
    dashboard: 'dashboard',
    area_master: 'area_master',
    zone_master: 'zone_master',
    dispatched: 'dispatched',
    usage_analytics: 'usage_analytics',
    driver_master: 'driver_master',
    device_master: 'device_master',
    assigned_devices: 'assigned_devices',
    plant_master: 'plant_master',
    dashboard_analytics: 'dashboard_analytics',
}
// to display modules on landing pages based on user role
export const LANDING_PAGE_MODULE_PRIVILEGE = {
    viewer: [LANDING_PAGE_MODULE_CODE.dashboard, LANDING_PAGE_MODULE_CODE.area_master, LANDING_PAGE_MODULE_CODE.zone_master, LANDING_PAGE_MODULE_CODE.dispatched],
    dispatch: [LANDING_PAGE_MODULE_CODE.dashboard, LANDING_PAGE_MODULE_CODE.area_master, LANDING_PAGE_MODULE_CODE.zone_master, LANDING_PAGE_MODULE_CODE.dispatched],
    manufacturing: [LANDING_PAGE_MODULE_CODE.dashboard, LANDING_PAGE_MODULE_CODE.area_master, LANDING_PAGE_MODULE_CODE.zone_master, LANDING_PAGE_MODULE_CODE.dispatched, LANDING_PAGE_MODULE_CODE.usage_analytics, LANDING_PAGE_MODULE_CODE.driver_master, LANDING_PAGE_MODULE_CODE.device_master, LANDING_PAGE_MODULE_CODE.assigned_devices, LANDING_PAGE_MODULE_CODE.plant_master],
    admin: [LANDING_PAGE_MODULE_CODE.dashboard, LANDING_PAGE_MODULE_CODE.area_master, LANDING_PAGE_MODULE_CODE.zone_master, LANDING_PAGE_MODULE_CODE.dispatched, LANDING_PAGE_MODULE_CODE.usage_analytics, LANDING_PAGE_MODULE_CODE.driver_master, LANDING_PAGE_MODULE_CODE.device_master, LANDING_PAGE_MODULE_CODE.assigned_devices, LANDING_PAGE_MODULE_CODE.dashboard_analytics],
    contractor: [LANDING_PAGE_MODULE_CODE.dashboard, LANDING_PAGE_MODULE_CODE.area_master, LANDING_PAGE_MODULE_CODE.zone_master, LANDING_PAGE_MODULE_CODE.dispatched, LANDING_PAGE_MODULE_CODE.usage_analytics, LANDING_PAGE_MODULE_CODE.driver_master, LANDING_PAGE_MODULE_CODE.device_master, LANDING_PAGE_MODULE_CODE.assigned_devices],
}
// keys for create usage analytics
export const path_Operation = [
    { name: '/dashboard', operation: 'view', pageName: 'Dashboard' },
    { path: "/dashboard/vin-details", operation: 'view', pageName: "VIN Details" },
    { name: '/dashboard/all-VINs', operation: 'view', pageName: 'All VINs' },
    { name: '/dashboard/all-VINs/vin-details', operation: 'view', pageName: 'VIN Details' },
    { name: '/dispatched', operation: 'view', pageName: 'Dispatch' },
    { name: '/dispatched/vin-details', operation: 'view', pageName: 'VIN Details' },

    // area
    { name: '/area-master', operation: 'view', pageName: 'Area Master' },
    { name: '/area-master/area-details', operation: 'view', pageName: 'Area Details' },
    { name: 'delete-area-multiple', operation: 'delete', pageName: 'Area Master' },
    { name: 'delete-area', operation: 'delete', pageName: 'Area Master' },

    { name: '/area-master/add-new-area', operation: 'view', pageName: 'Create Area' },
    { name: '/area-master/edit-area', operation: 'view', pageName: 'Edit Area' },
    { name: 'create-area', operation: 'create', pageName: 'Area Master' },
    { name: 'edit-area', operation: 'edit', pageName: 'Area Master' },

    // zone
    { name: '/zone-master', operation: 'view', pageName: 'Zone Master' },
    { name: '/zone-master/zone-details', operation: 'view', pageName: 'Zone Details' },
    { name: 'delete-zone-multiple', operation: 'delete', pageName: 'Zone Master' },
    { name: 'delete-zone', operation: 'delete', pageName: 'Zone Master' },

    { name: '/zone-master/add-new-zone', operation: 'view', pageName: 'Create Zone' },
    { name: '/zone-master/edit-zone', operation: 'view', pageName: 'Edit Zone' },
    { name: 'create-zone', operation: 'create', pageName: 'Zone Master' },
    { name: 'edit-zone', operation: 'edit', pageName: 'Zone Master' },

    //driver
    { name: '/driver-master', operation: 'view', pageName: 'Driver Onboarding' },
    { name: 'delete-driver-multiple', operation: 'delete', pageName: 'Driver Onboarding' },
    { name: 'delete-driver', operation: 'delete', pageName: 'Driver Onboarding' },

    { name: '/driver-master/add-new-driver', operation: 'view', pageName: 'Create Driver' },
    { name: '/driver-master/edit-driver', operation: 'view', pageName: 'Edit Driver' },
    { name: 'create-driver', operation: 'create', pageName: 'Driver Onboarding' },
    { name: 'edit-driver', operation: 'edit', pageName: 'Driver Onboarding' },

    //device
    { name: '/device-master', operation: 'view', pageName: 'Device Onboarding' },
    { name: 'delete-device-multiple', operation: 'delete', pageName: 'Device Onboarding' },
    { name: 'delete-device', operation: 'delete', pageName: 'Device Onboarding' },

    { name: '/device-master/add-new-device', operation: 'view', pageName: 'Create Device' },
    { name: '/device-master/edit-device', operation: 'view', pageName: 'Edit Device' },
    { name: 'create-device', operation: 'create', pageName: 'Device Onboarding' },
    { name: 'edit-device', operation: 'edit', pageName: 'Device Onboarding' },

    { name: '/device-assignment', operation: 'view', pageName: 'Device Assignment' },

    // Plant Master
    { name: '/plant-master', operation: 'view', pageName: 'Plant Geofence' },
    { name: '/plant-master/edit-plant', operation: 'view', pageName: 'Edit Plant' },
    { name: '/plant-master/plant-details', operation: 'view', pageName: 'Plant Details' },
    { name: 'edit-plant', operation: 'edit', pageName: 'Plant Geofence' },

    // Dashboard Analytics
    { name: '/dashboard-analytics', operation: 'view', pageName: 'Overall Summary' },
]
export const routes_auth = {
    edit: ["/area-master/edit-area", "/zone-master/edit-zone", "/driver-master/edit-driver"]
}
export const plant = "all";

export const device_status = [
    { label: "Active", value: "1" },
    { label: "Inactive", value: "0" },
]

export const polygon_stroke_color = "#F17C7C";
export const polygon_stroke_opacity = 0.6;
export const polygon_stroke_width = 5;
export const polygon_fill_color = "#B7B7B7";
export const polygon_fill_opacity = 0.3;

export const polygon_fill_color_red = "#F17C7C";

export const plant_options = [
    // { label: "India", value: "all" },
    { label: "Pune", value: "1001" },
    { label: "Jamshedpur", value: "2001" },
    { label: "Lucknow", value: "3001" },
    { label: "Dharwad", value: "1500" },
    { label: "Sanand", value: "3100" },
];

export const excludeSecondaryNavbar = ["/dashboard/all-vins"];

export const navbarTabs = [
    {
        name: "Dashboard",
        link: "/dashboard",
        exact: true,
        icon: (
            <path
                d="M8.687 1.26162C8.50133 1.08609 8.25551 0.988281 8 0.988281C7.74449 0.988281 7.49867 1.08609 7.313 1.26162L2.469 5.83962C2.32068 5.97998 2.20258 6.14914 2.12194 6.33673C2.04129 6.52433 1.9998 6.72642 2 6.93062V12.5006C2.00027 12.8983 2.15842 13.2796 2.43969 13.5606C2.72097 13.8417 3.10235 13.9996 3.5 13.9996H5C5.39783 13.9996 5.77936 13.8416 6.06066 13.5603C6.34197 13.279 6.5 12.8974 6.5 12.4996V9.99962C6.5 9.86702 6.55268 9.73984 6.64645 9.64607C6.74022 9.5523 6.86739 9.49962 7 9.49962H9C9.13261 9.49962 9.25979 9.5523 9.35355 9.64607C9.44732 9.73984 9.5 9.86702 9.5 9.99962V12.4996C9.5 12.8974 9.65804 13.279 9.93934 13.5603C10.2206 13.8416 10.6022 13.9996 11 13.9996H12.5C12.8978 13.9996 13.2794 13.8416 13.5607 13.5603C13.842 13.279 14 12.8974 14 12.4996V6.92962C13.9999 6.72552 13.9582 6.52358 13.8774 6.33615C13.7966 6.14873 13.6784 5.97977 13.53 5.83962L8.687 1.25962V1.26162Z"
                fill="white"
            />
        ),
    },
    {
        name: "Dispatched",
        link: "/dispatched",
        exact: false,
        icon: (
            <>
                <path
                    d="M16.6331 11.9579L16.7742 11.8168L16.6331 11.9579C16.7405 12.0653 16.8009 12.2109 16.8009 12.3629V16.2265C16.8009 16.3785 16.7405 16.5242 16.6331 16.6316L16.7745 16.773L16.6331 16.6316C16.5257 16.739 16.38 16.7994 16.2281 16.7994H0.772857C0.62091 16.7994 0.47524 16.739 0.367818 16.6316C0.260371 16.5241 0.2 16.3786 0.2 16.2267V12.3627C0.2 12.2108 0.260397 12.0651 0.367818 11.9577C0.475241 11.8502 0.620898 11.7898 0.772857 11.7898H16.2281C16.3799 11.7898 16.5256 11.8503 16.6331 11.9579Z"
                    fill="white"
                    stroke="white"
                    strokeWidth="0.4"
                />
                <path
                    d="M4.9992 0.33824C5.04224 0.299538 5.08966 0.266128 5.14046 0.238694H5.16261H5.19298L5.22199 0.229676C5.2707 0.214532 5.32098 0.2046 5.37196 0.200012L5.40996 0.200015L5.41114 0.200008C5.48851 0.199553 5.56496 0.218239 5.63371 0.254392L5.64519 0.260432L5.65736 0.264936C5.71752 0.287206 5.77224 0.321741 5.81796 0.366392L8.13552 2.68395L8.13616 2.68459C8.24453 2.79198 8.30554 2.93838 8.30554 3.09117C8.30554 3.24377 8.24456 3.39022 8.13609 3.49783L8.13494 3.49898C8.02737 3.60743 7.88093 3.66841 7.72829 3.66841C7.57906 3.66841 7.4359 3.61021 7.32921 3.50647L7.32161 3.49881L6.32466 2.49425L5.98271 2.14968V2.63513V10.0461C5.98271 10.2507 5.8735 10.4398 5.69627 10.5422C5.51907 10.6445 5.30075 10.6445 5.12355 10.5422C4.94632 10.4398 4.83712 10.2507 4.83712 10.0461V2.63513V2.14959L4.49514 2.49427L3.4999 3.49737C3.34959 3.64287 3.13318 3.69741 2.93188 3.64042L2.93178 3.64039C2.73007 3.58339 2.57406 3.42304 2.52264 3.21976L2.52264 3.21976C2.4712 3.01643 2.53211 2.80116 2.68242 2.655L2.68243 2.65501L2.68441 2.65303L4.9992 0.33824Z"
                    fill="white"
                    stroke="white"
                    strokeWidth="0.4"
                />
                <mask id="path-3-inside-1_1160_1904" fill="white">
                    <path d="M8.72727 8.27651L11.0456 10.5948C11.1117 10.6595 11.1907 10.7096 11.2774 10.7417C11.3764 10.7897 11.4844 10.8159 11.5943 10.8189C11.6944 10.8166 11.7936 10.7983 11.8879 10.7648C11.9818 10.7228 12.068 10.6653 12.1429 10.5948L14.4612 8.27651C14.6574 8.08051 14.7338 7.79473 14.6621 7.52693C14.5903 7.25927 14.3811 7.05009 14.1135 6.97829C13.8457 6.90661 13.5599 6.98307 13.3639 7.1792L12.3671 8.18376V0.772761C12.3671 0.496686 12.2198 0.241569 11.9807 0.103529C11.7416 -0.0345098 11.447 -0.0345098 11.2079 0.103529C10.9689 0.241569 10.8215 0.496683 10.8215 0.772761V8.18376L9.82457 7.1792C9.62858 6.98307 9.34293 6.90661 9.07513 6.97829C8.80733 7.05009 8.59828 7.25928 8.52648 7.52693C8.45468 7.79473 8.53127 8.08051 8.72727 8.27651H8.72727Z" />
                </mask>
                <path
                    d="M8.72727 8.27651L11.0456 10.5948C11.1117 10.6595 11.1907 10.7096 11.2774 10.7417C11.3764 10.7897 11.4844 10.8159 11.5943 10.8189C11.6944 10.8166 11.7936 10.7983 11.8879 10.7648C11.9818 10.7228 12.068 10.6653 12.1429 10.5948L14.4612 8.27651C14.6574 8.08051 14.7338 7.79473 14.6621 7.52693C14.5903 7.25927 14.3811 7.05009 14.1135 6.97829C13.8457 6.90661 13.5599 6.98307 13.3639 7.1792L12.3671 8.18376V0.772761C12.3671 0.496686 12.2198 0.241569 11.9807 0.103529C11.7416 -0.0345098 11.447 -0.0345098 11.2079 0.103529C10.9689 0.241569 10.8215 0.496683 10.8215 0.772761V8.18376L9.82457 7.1792C9.62858 6.98307 9.34293 6.90661 9.07513 6.97829C8.80733 7.05009 8.59828 7.25928 8.52648 7.52693C8.45468 7.79473 8.53127 8.08051 8.72727 8.27651H8.72727Z"
                    fill="white"
                />
                <path
                    d="M8.72727 8.27651L9.01012 7.99367L8.89296 7.87651H8.72727V8.27651ZM11.0456 10.5948L10.7627 10.8777L10.7658 10.8807L11.0456 10.5948ZM11.2774 10.7417L11.452 10.3818L11.4345 10.3733L11.4163 10.3665L11.2774 10.7417ZM11.5943 10.8189L11.5834 11.2187L11.5935 11.219L11.6036 11.2188L11.5943 10.8189ZM11.8879 10.7648L12.0218 11.1417L12.0368 11.1364L12.0514 11.1299L11.8879 10.7648ZM12.1429 10.5948L12.4172 10.8862L12.4258 10.8777L12.1429 10.5948ZM14.4612 8.27651L14.1785 7.99357L14.1784 7.99367L14.4612 8.27651ZM14.6621 7.52693L15.0485 7.42352L15.0485 7.4233L14.6621 7.52693ZM14.1135 6.97829L14.2171 6.59195L14.2169 6.59189L14.1135 6.97829ZM13.3639 7.1792L13.081 6.89645L13.08 6.89745L13.3639 7.1792ZM12.3671 8.18376H11.9671V9.15476L12.651 8.4655L12.3671 8.18376ZM11.2079 0.103529L11.0079 -0.242879L11.0079 -0.242876L11.2079 0.103529ZM10.8215 8.18376L10.5376 8.46552L11.2215 9.15466V8.18376H10.8215ZM9.82457 7.1792L10.1085 6.89743L10.1075 6.89645L9.82457 7.1792ZM9.07513 6.97829L8.97171 6.59189L8.97154 6.59193L9.07513 6.97829ZM8.52648 7.52693L8.14014 7.42329L8.14013 7.42334L8.52648 7.52693ZM8.72727 8.27651L8.44442 8.55935L8.56158 8.67651H8.72727V8.27651ZM8.44443 8.55935L10.7627 10.8777L11.3284 10.312L9.01012 7.99367L8.44443 8.55935ZM10.7658 10.8807C10.8721 10.9847 10.9991 11.0652 11.1386 11.1168L11.4163 10.3665C11.3824 10.354 11.3513 10.3343 11.3253 10.3089L10.7658 10.8807ZM11.1029 11.1016C11.2531 11.1744 11.417 11.2142 11.5834 11.2187L11.6051 10.419C11.5518 10.4176 11.4996 10.4049 11.452 10.3818L11.1029 11.1016ZM11.6036 11.2188C11.746 11.2155 11.8873 11.1895 12.0218 11.1417L11.754 10.3879C11.6999 10.4071 11.6427 10.4177 11.585 10.419L11.6036 11.2188ZM12.0514 11.1299C12.186 11.0696 12.3096 10.9872 12.4171 10.8861L11.8687 10.3036C11.8264 10.3434 11.7777 10.3759 11.7245 10.3997L12.0514 11.1299ZM12.4258 10.8777L14.7441 8.55935L14.1784 7.99367L11.8601 10.312L12.4258 10.8777ZM14.744 8.55945C15.0413 8.26227 15.1571 7.82915 15.0485 7.42352L14.2757 7.63035C14.3105 7.76031 14.2734 7.89875 14.1785 7.99357L14.744 8.55945ZM15.0485 7.4233C14.9397 7.01767 14.6227 6.70075 14.2171 6.59195L14.0099 7.36463C14.1396 7.39942 14.241 7.50086 14.2758 7.63057L15.0485 7.4233ZM14.2169 6.59189C13.8113 6.48332 13.3782 6.59908 13.081 6.89645L13.6469 7.46195C13.7417 7.36706 13.8801 7.32991 14.0101 7.36469L14.2169 6.59189ZM13.08 6.89745L12.0832 7.90201L12.651 8.4655L13.6479 7.46094L13.08 6.89745ZM12.7671 8.18376V0.772761H11.9671V8.18376H12.7671ZM12.7671 0.772761C12.7671 0.353721 12.5435 -0.0334134 12.1807 -0.242876L11.7807 0.449935C11.896 0.516551 11.9671 0.639651 11.9671 0.772761H12.7671ZM12.1807 -0.242876C11.8178 -0.452376 11.3708 -0.452373 11.0079 -0.242879L11.408 0.449937C11.5233 0.383353 11.6654 0.383356 11.7807 0.449935L12.1807 -0.242876ZM11.0079 -0.242876C10.6452 -0.0334139 10.4215 0.353717 10.4215 0.772761H11.2215C11.2215 0.639648 11.2926 0.516551 11.408 0.449935L11.0079 -0.242876ZM10.4215 0.772761V8.18376H11.2215V0.772761H10.4215ZM11.1054 7.90199L10.1085 6.89743L9.54066 7.46096L10.5376 8.46552L11.1054 7.90199ZM10.1075 6.89645C9.81036 6.59911 9.37739 6.48331 8.97171 6.59189L9.17854 7.36469C9.30847 7.32991 9.44679 7.36704 9.54164 7.46195L10.1075 6.89645ZM8.97154 6.59193C8.56568 6.70075 8.24893 7.01777 8.14014 7.42329L8.91282 7.63057C8.94764 7.50079 9.04899 7.39942 9.17872 7.36464L8.97154 6.59193ZM8.14013 7.42334C8.03131 7.82921 8.14737 8.2623 8.44442 8.55935L9.01011 7.99367C8.91516 7.89872 8.87805 7.76024 8.91284 7.63052L8.14013 7.42334ZM8.72727 8.67651H8.72727V7.87651H8.72727V8.67651Z"
                    fill="white"
                    mask="url(#path-3-inside-1_1160_1904)"
                />
            </>
        ),
    },
    {
        name: "Zone Master",
        link: "/zone-master",
        exact: false,
        icon: (
            <path
                d="M6.06384 0.00036102L0 2.42586V15.3621L6.06384 12.9366V0.00036102ZM6.46806 0.00036102V12.9366L12.5319 15.3621V9.27295L9.94849 3.91042C9.81821 3.56625 9.70838 3.06376 9.70838 2.67235C9.70838 2.21919 9.80834 1.79594 9.97993 1.40905L6.46807 0.000397094L6.46806 0.00036102ZM12.7279 0.00036102C11.2765 0.00036102 10.1065 1.21064 10.1065 2.7101C10.1065 3.05455 10.2021 3.49375 10.3149 3.79661L12.7342 8.89385L15.1534 3.79625C15.2669 3.4934 15.3618 3.05434 15.3618 2.70974C15.3618 1.21028 14.1791 0 12.7277 0L12.7279 0.00036102ZM19 0.00036102L15.4943 1.4027C15.6697 1.79168 15.7722 2.21623 15.7722 2.67235C15.7722 3.0639 15.6631 3.56612 15.5323 3.91042L12.9362 9.29821V15.3621L19 12.9366L19 0.00036102ZM12.734 1.41522C13.4038 1.41522 13.9469 1.95819 13.9469 2.62806C13.9469 3.29794 13.4039 3.8409 12.734 3.8409C12.0642 3.8409 11.5212 3.29794 11.5212 2.62806C11.5212 1.95819 12.0642 1.41522 12.734 1.41522Z"
                fill="white"
            />
        ),
    },
    {
        name: "Area Master",
        link: "/area-master",
        exact: false,
        icon: (
            <path
                d="M6.06384 0.00036102L0 2.42586V15.3621L6.06384 12.9366V0.00036102ZM6.46806 0.00036102V12.9366L12.5319 15.3621V9.27295L9.94849 3.91042C9.81821 3.56625 9.70838 3.06376 9.70838 2.67235C9.70838 2.21919 9.80834 1.79594 9.97993 1.40905L6.46807 0.000397094L6.46806 0.00036102ZM12.7279 0.00036102C11.2765 0.00036102 10.1065 1.21064 10.1065 2.7101C10.1065 3.05455 10.2021 3.49375 10.3149 3.79661L12.7342 8.89385L15.1534 3.79625C15.2669 3.4934 15.3618 3.05434 15.3618 2.70974C15.3618 1.21028 14.1791 0 12.7277 0L12.7279 0.00036102ZM19 0.00036102L15.4943 1.4027C15.6697 1.79168 15.7722 2.21623 15.7722 2.67235C15.7722 3.0639 15.6631 3.56612 15.5323 3.91042L12.9362 9.29821V15.3621L19 12.9366L19 0.00036102ZM12.734 1.41522C13.4038 1.41522 13.9469 1.95819 13.9469 2.62806C13.9469 3.29794 13.4039 3.8409 12.734 3.8409C12.0642 3.8409 11.5212 3.29794 11.5212 2.62806C11.5212 1.95819 12.0642 1.41522 12.734 1.41522Z"
                fill="white"
            />
        ),
    },
    {
        name: "Test",
        link: "/test",
        exact: true,
        icon: (
            <path
                d="M8.687 1.26162C8.50133 1.08609 8.25551 0.988281 8 0.988281C7.74449 0.988281 7.49867 1.08609 7.313 1.26162L2.469 5.83962C2.32068 5.97998 2.20258 6.14914 2.12194 6.33673C2.04129 6.52433 1.9998 6.72642 2 6.93062V12.5006C2.00027 12.8983 2.15842 13.2796 2.43969 13.5606C2.72097 13.8417 3.10235 13.9996 3.5 13.9996H5C5.39783 13.9996 5.77936 13.8416 6.06066 13.5603C6.34197 13.279 6.5 12.8974 6.5 12.4996V9.99962C6.5 9.86702 6.55268 9.73984 6.64645 9.64607C6.74022 9.5523 6.86739 9.49962 7 9.49962H9C9.13261 9.49962 9.25979 9.5523 9.35355 9.64607C9.44732 9.73984 9.5 9.86702 9.5 9.99962V12.4996C9.5 12.8974 9.65804 13.279 9.93934 13.5603C10.2206 13.8416 10.6022 13.9996 11 13.9996H12.5C12.8978 13.9996 13.2794 13.8416 13.5607 13.5603C13.842 13.279 14 12.8974 14 12.4996V6.92962C13.9999 6.72552 13.9582 6.52358 13.8774 6.33615C13.7966 6.14873 13.6784 5.97977 13.53 5.83962L8.687 1.25962V1.26162Z"
                fill="white"
            />
        ),
    },
];

export const APILimit = 100000000;

export const bulkUploadLimit = 200

export const usageAnalyticsHeader = [
    {
        width: 200,
        title: "User",
        field: "user_name",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 150,
        title: "Page",
        field: "page",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 130,
        title: "Operation",
        field: "operation",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 200,
        title: "Duration",
        field: "duration",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 200,
        title: "Timestamp",
        field: "time",
        enableSearch: true,
        enableFilter: true,
    },
];

export const zoneTableHeader = [
    {
        name: "Zone Name",
        icon: true,
        vars: "zone_name",
    },
    {
        name: "Area",
        icon: true,
        vars: "area_fk__area_name",
    },
    {
        name: "Capacity",
        icon: true,
        vars: "parking_capacity",
    },
    {
        name: "Parent Zone",
        icon: true,
        vars: "parent_zone",
    },
    {
        name: "Plant",
        icon: true,
        vars: "plant_fk__plant_name",
    },
    {
        name: "Last Updated At",
        icon: true,
        vars: "updated_at",
    },
    {
        name: "Updated By",
        icon: true,
        vars: "updated_by",
    },
    {
        name: "Actions",
        icon: false,
        vars: "action",
    },
];

export const areaTableHeader = [
    {
        name: "Area",
        icon: false,
        vars: "area_name",
    },
    {
        name: "Plant",
        icon: true,
        vars: "plant_fk__plant_name",
    },
    {
        name: "Description",
        icon: true,
        vars: "area_description",
    },
    {
        name: "Last Updated At",
        icon: true,
        vars: "updated_at",
    },
    {
        name: "Updated By",
        icon: true,
        vars: "updated_by",
    },
    {
        name: "Actions",
        icon: false,
        vars: "action",
    },
];

export const dispatchTableHeader = [
    {
        width: 200,
        title: "Vehicle",
        field: "vin_number",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 150,
        title: "Last Sceen At",
        field: "vin_last_seen_at",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 130,
        title: "Vehicle Status",
        field: "vin_status",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 200,
        title: "Updated At",
        field: "updated_at",
        enableSearch: true,
        enableFilter: true,
    },
];

export const allVINsTableHeader = [
    {
        width: 200,
        title: "Vehicle",
        field: "vin_number",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 150,
        title: "Vehicle Status",
        field: "vin_status",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 150,
        title: "VC Number",
        field: "vc_number",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 300,
        title: "VC Description",
        field: "vc_description",
        enableSearch: true,
        enableFilter: true,
    },
    // {
    //     width: 200,
    //     title: "Last Seen At",
    //     field: "vin_last_seen_at",
    //     enableSearch: true,
    //     enableFilter: true,
    // },
    {
        width: 170,
        title: "Last Seen Area",
        field: "area_fk__area_name",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 170,
        title: "Last Seen Zone",
        field: "zone_fk__zone_name",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 200,
        title: "From",
        field: "data_source",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 200,
        title: "Fuel",
        field: "fuel_level",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 200,
        title: "Fuel Updated At",
        field: "fuel_vin_fk__fuel_updated_at",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 200,
        title: "Location Updated At",
        field: "location_updated_at",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 200,
        title: "Status Updated At",
        field: "last_sync_date",
        enableSearch: true,
        enableFilter: true,
    },
];

export const zoneListTableHeader = [
    {
        width: 200,
        title: "Zone Name",
        field: "zone_name",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 200,
        title: "Area Name",
        field: "area_fk__area_name",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 200,
        title: "Parking Capacity",
        field: "parking_capacity",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 150,
        title: "Parent Zone",
        field: "parent_zone_name",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 150,
        title: "Plant Name",
        field: "plant_fk__plant_name",
        enableSearch: true,
        enableFilter: true,
    },
    // {
    //     width: 180,
    //     title: "Created At",
    //     field: "created_at",
    //     enableSearch: true,
    //     enableFilter: true,
    // },
    // {
    //     width: 150,
    //     title: "Created By",
    //     field: "created_by",
    //     enableSearch: true,
    //     enableFilter: true,
    // },
    {
        width: 180,
        title: "Last Updated At",
        field: "updated_at",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 150,
        title: "Updated By",
        field: "updated_by",
        enableSearch: true,
        enableFilter: true,
    },
    // {
    //     width: 200,
    //     title:"Actions",
    //     field:"updated_at",
    //     enableSearch: true,
    //     enableFilter: true,
    // },
];

export const areaListTableHeader = [
    {
        width: 200,
        title: "Area Name",
        field: "area_name",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 150,
        title: "Plant Name",
        field: "plant_fk__plant_name",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 150,
        title: "Description",
        field: "area_description",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 180,
        title: "Parking Capacity",
        field: "parking_capacity",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 180,
        title: "Last Updated At",
        field: "updated_at",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 150,
        title: "Updated By",
        field: "updated_by",
        enableSearch: true,
        enableFilter: true,
    },
];

// export const dispatchTableHeader = [
//     {
//         name: "VINS",
//         icon: true
//     },
//     {
//         name: "Last Seen At",
//         icon: true
//     },
//     {
//         name: "VIN Status",
//         icon: true
//     },
//     {
//         name: "Last Updated At",
//         icon: true
//     },
// ]

export const dispatchedHistoryTableHeader = [
    {
        width: 200,
        title: "Vehicle",
        field: "vin_number",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 150,
        title: "VC Number",
        field: "vc_number",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 300,
        title: "VC Description",
        field: "vc_description",
        enableSearch: true,
        enableFilter: true,
    },
    // {
    //     width: 150,
    //     title: "Billing Status",
    //     field: "billing_status",
    //     enableSearch: true,
    //     enableFilter: true,
    // },
    {
        width: 200,
        title: "Vehicle Status",
        field: "vin_status",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 170,
        title: "Last Seen Area",
        field: "area_name",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 170,
        title: "Last Seen Zone",
        field: "zone_name",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 200,
        title: "From",
        field: "data_source",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 200,
        title: "Fuel",
        field: "fuel_level",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 200,
        title: "Fuel Updated At",
        field: "fuel_vin_fk__fuel_updated_at",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 200,
        title: "Location Updated At",
        field: "dispatch_updated_at",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 200,
        title: "Status Updated At",
        field: "last_sync_date",
        enableSearch: true,
        enableFilter: true,
    },
];

export const vinDetailsHeader = [
    "Vehicle Number",
    "Last Seen At",
    "Type of Vehicle",
    "Vehicle Status",
    "Latitude",
    "VC Number",
    "Longitude",
    "Location Updated At",
    "VC Description",
    "Status Updated At",
    "Fuel",
    "Fuel Updated At",
];

export const allVINsFilter = [
    { value: "all", label: "All" },
    { value: "True", label: "Parked" },
    { value: "False", label: "Non Parked" },
];

export const allDispatchFilter = [
    { value: "all", label: "All" },
    { value: "days", label: "0 - 30 Days" },
    { value: "onemonth", label: "31 - 60 Days" },
    { value: "twomonth", label: "61 - 90 Days" },
    { value: "threemonth", label: "Above 90 Days" }
];

export const DispatchFilter = [
    { value: "all", label: "All" },
    { value: "current", label: "Today's" },
    { value: "week", label: "This Week" },
    { value: "month", label: "This Month" },
];

export const UsageAnalyticsFilter = [
    { value: "all", label: "All" },
    { value: "current", label: "Today's" },
    { value: "week", label: "This Week" },
    { value: "month", label: "This Month" },
];

export const zoneMasterFilter = [
    { label: "Parking Area 1", value: "parking_area_1" },
    { label: "Parking Area 2", value: "parking area 2" },
    { label: "Parking Area 3", value: "parking area 3" },
    { label: "Parking Area 4", value: "parking area 4" },
    { label: "Parking Area 5", value: "parking area 5" },
];

export const areaMasterFilter = [
    { label: "Parking Area 1", value: "parking_area_1" },
    { label: "Parking Area 2", value: "parking area 2" },
];

export const areaMasterheader = [
    { name: "Plant", vars: "plant_fk__plant_name" },
    { name: "Last Updated At", vars: "updated_at" },
];

export const zoneMasterheader = [
    { name: "Parking Capacity", vars: "parking_capacity" },
    { name: "Parent Zone", vars: "parent_zone_name" },
    { name: "Area", vars: "area_fk__area_name" },
];

export const defaultColumns = [
    {
        width: 120,
        title: "ASN",
        field: "asn",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 150,
        title: "VC Status",
        field: "asnStatus",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 120,
        title: "Part",
        field: "material",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 120,
        title: "Part Status",
        field: "materialStatus",
        enableSearch: true,
        enableFilter: true,
    },
];

export const excludeDownload = [
    "vin_id",
    "coordinates",
    "billing_status",
    "id",
    "zone_id",
    "parent_zone",
    "plant_fk__plant_id",
    "area_fk__area_id",
    "zoom",
    "area_fk__zoom",
    "plant_fk__zoom",
    "parent_zone_id",
    "plant_fk_coordinates",
    "area_fk_coordinates",
    "area_id",
    "driver_id",
    "device_id",
    "password_reset_time",
    "reset_pin",
    "device_fk_id__device_id",
    "plant_id",
    "plant_coordinates",
    "vin_type",
    ""
]

export const dateFieldHeader = [
    "dispatch_updated_at",
    "last_sync_date",
    "updated_at",
    "time",
    "fuel_vin_fk__fuel_updated_at",
    "in_time",
    "out_time",
    "location_updated_at"
]

export const MESSAGE_TYPE = {
    SUCCESS: 'Success',
    FAILURE: 'Fail',
    INFORMATION: 'Information',
    INTERNAL_ERROR: 'Internal Error',
    LOADING: 'Loading',
};
export const AUTH_CODE = {
    EDIT: ['edit', 'Manufacturing', 'admin'],
    DELETE: ['delete', 'Manufacturing', 'admin'],
    DOWNLOAD: ['download', 'Manufacturing', 'admin', "Dispatch", "viewer"],
    RESYNC_FUEL: ['download', 'Manufacturing', 'admin', "Dispatch", "viewer"],
    CREATE: ['create', 'Manufacturing', 'admin'],
    MANUFACTURING: "Manufacturing"
};

export const vinHeader = [
    {
        name: "Last Seen At",
        vars: "zone_fk__zone_name",
    },
    {
        name: "Vehicle Status",
        vars: "vin_status",
    },
    {
        name: "Last Updated At",
        vars: "updated_at"
    }
];

export const plantHeader = [
    {
        name: "Parked",
        vars: "parked",
    },
    {
        name: "Non Parked",
        vars: "non_parked",
    },
    {
        name: "Avg. Age",
        vars: "avg_age"
    }
];

export const driverListTableHeader = [
    {
        width: 150,
        title: "First Name",
        field: "first_name",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 150,
        title: "Last Name",
        field: "last_name",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 200,
        title: "Contractor Name",
        field: "contracter_name",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 250,
        title: "Contractor Phone No.",
        field: "contracter_mobile_no",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 200,
        title: "Driver Phone No.",
        field: "driver_mobile_no",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 180,
        title: "Updated At",
        field: "updated_at",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 150,
        title: "Updated By",
        field: "updated_by",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 200,
        title: "Reset Pin",
        field: "reset_pin",
        enableSearch: false,
        enableFilter: false,
    },
];
export const deviceListTableHeader = [
    {
        width: 150,
        title: "Manufacturer",
        field: "manufacturer_name",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 150,
        title: "Modal Name",
        field: "model_name",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 200,
        title: "IMEI 1",
        field: "imei_1",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 200,
        title: "IMEI 2",
        field: "imei_2",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 250,
        title: "SIM Card Number",
        field: "sim_card_number",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 180,
        title: "Updated At",
        field: "updated_at",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 150,
        title: "Updated By",
        field: "updated_by",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 200,
        title: "Status",
        field: "status",
        enableSearch: false,
        enableFilter: false,
    },
];
export const deviceAsnListTableHeader = [
    {
        width: 250,
        title: "Device Manufacturer",
        field: "manufacturer_name",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 150,
        title: "Device IMEI 1",
        field: "imei_1",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 150,
        title: "Device IMEI 2",
        field: "imei_2",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 250,
        title: "Device SIM Card Number",
        field: "sim_card_number",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 250,
        title: "Driver Number",
        field: "driver_mobile_no",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 180,
        title: "Login At",
        field: "in_time",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 150,
        title: "Logout At",
        field: "out_time",
        enableSearch: true,
        enableFilter: true,
    },
];
export const plantMasterListTableHeader = [
    {
        width: 250,
        title: "Plant Name",
        field: "plant_name",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 250,
        title: "Plant ID",
        field: "plant_ids",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 250,
        title: "Category",
        field: "plant_category",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 180,
        title: "Updated At",
        field: "updated_at",
        enableSearch: true,
        enableFilter: true,
    },
    {
        width: 150,
        title: "Updated By",
        field: "updated_by",
        enableSearch: true,
        enableFilter: true,
    },
];

export const reset_pin_timer = 10

export const resync_fuel_count = 50

export const resync_fuelBtn_message = "Select VINs between 1-50 to Resync Fuel"
